import state from './state.js'
import actions from './actions.js'

export default {
  namespaced: true,
  state,
  mutations: {
    SET_LINE_SETTINGS (state, payload) {
      state.lineAt = payload.lineAt
      state.linkLine = payload.linkLine
    },
    SET_SETTINGS_LOADED (state, val) {
      state.loaded = !!val
    }
  },
  actions,
  getters: {
    lineAt: (state) => state.lineAt,
    linkLine: (state) => state.linkLine
  }
}

